import React from 'react';
import ComponentHelper from '../../../supers/ComponentHelper';
import './integration-endpoint-form.css';
import RESTService from '../../../services/RESTService';
import CommonService from '../../../services/CommonService';
import Dropdown from '../../../components/dropdown/Dropdown';
import rest from '../../connections-panel/connection-creator/rest.png';
import ex10 from '../../connections-panel/connection-creator/e2010.png';
import exchange from '../../connections-panel/connection-creator/exchange.png';
import htmlImg from '../../connections-panel/connection-creator/html.png';
import soap from '../../connections-panel/connection-creator/soap.png';
import sqlImg from '../../connections-panel/connection-creator/sql.png';
import _ from 'lodash';
import HttpConnector from '../../connections-panel/connection-creator/http-connector/HttpConnector';
import SoapConnector from '../../connections-panel/connection-creator/soap-connector/SoapConnector';
import HtmlConnector from '../../connections-panel/connection-creator/html-connector/HtmlConnector';
import ExchangeConnector from '../../connections-panel/connection-creator/exchange-connector/ExchangeConnector';
import ExchangeWebServiceConnector from '../../connections-panel/connection-creator/exchangewebservice-connector/ExchangeWebServiceConnector';
import SqlConnector from '../../connections-panel/connection-creator/sql-connector/SqlConnector';
import ToggleRow from '../../../components/toggle-row/ToggleRow';
import CodeEditor from '../../../components/code-editor/CodeEditor';
import InputField from '../../../components/input-field/InputField';
import ValidationService from '../../../services/ValidationService';
import SampleRequestCard from '../../../components/sample-request-card/SampleRequestCard';
import TestRunnerModal from '../../../components/test-runner-modal/TestRunnerModal';
import ScriptHelp from './script-help/ScriptHelp';
import SmallJSONEditor from '../../../components/small-json-editor/SmallJSONEditor';
import RoutingService from '../../../services/RoutingService';
import AppConfigService from '../../../services/AppConfigService';
import TrackingService from '../../../services/TrackingService';
const connect = new RESTService();
const CS = new CommonService();
const VS = new ValidationService();
const RS = new RoutingService();
const ACS = new AppConfigService();
const TS = new TrackingService();

class IntegrationEndpointForm extends ComponentHelper {
	constructor(props) {
		super(props);
		this.data = {
			selectedConnection: null,
			connectionMap: {},
			preProcessingOpen: false,
			postProcessingOpen: false,
			preErrors: [],
			postErrors: [],
			actionType: 'get',
			validJS: true,
			runningTest: false,
			description: '',
			endpointType: 'Operation',
			name: '',
			async: false,
			cacheTime: 0,
			preScript: 'function prehook (config, ctx) {\n \treturn config;\n }',
			postScript: 'function posthook (response, ctx) {\n \treturn response;\n }',
			requestParams: {},
			paramFields: {},
			endpointConnection: null,
			actionRequired: true
		};
		this.preEditor = {};
		this.postEditor = {};
		if (this.props.endpoint) {
			this.setupExisting();
		}
		this.autoBind([
			'onConnectionChange',
			'renderConnection',
			'getConnectionImage',
			'handleConnectionChange',
			'onDDActionChange',
			'onChecked',
			'handlePreScriptChange',
			'handlePostScriptChange',
			'onValueChange',
			'onSaveEndpoint',
			'onTypeChange',
			'buildTypeDefault',
			'toggleAsync',
			'runTest',
			'toggleTestRunner',
			'onTestEndpoint',
			'onSetEmpty',
			'onClearValue',
			'onDefaultChange',
			'buildTemplate',
			'buildTestValues'
		]);
	}

	setupExisting = () => {
		let ep = this.props.endpoint;
		this.data.endpoint = ep;
		this.data.name = ep.name;
		this.data.endpointConnection = ep.connection;
		this.data.endpointType = ep.type;
		this.data.cacheTime = ep.cacheForMinutes ? ep.cacheForMinutes : 0;
		this.data.description = ep.description;
		this.data.actionType = ep.action ? ep.action : '';
		if (ep.hooks && ep.hooks['pre-processing']) {
			this.data.preScript = ep.hooks['pre-processing'];
			this.data.preProcessingOpen = true;
		}
		if (ep.hooks && ep.hooks['post-processing']) {
			this.data.postScript = ep.hooks['post-processing'];
			this.data.postProcessingOpen = true;
		}
		if (this.data.name.length > 0) {
			this.data.validJS = true;
		}
		if (ep.templates) {
			this.data.requestParams = {};
			this.data.paramFields = {};
			let params = Object.keys(ep.templates);
			_.forEach(params, param => {
				let tpl = ep.templates[param];
				this.data.paramFields[param] = {
					required: tpl.required,
					type: tpl.type
				};
				this.data.paramFields[param].value = tpl.default;
				if (tpl.type === 'object' || tpl.type === 'array') {
					this.data.paramFields[param].value = JSON.stringify(tpl.default);
				}
				if (tpl.type === 'boolean') {
					this.data.paramFields[param].label = typeof tpl.default === 'boolean' ? tpl.default.toString() : 'None';
					this.data.paramFields[param].value = Boolean(tpl.default);
				}
				if (tpl.type === 'contextHeader' && tpl.key) {
					this.data.paramFields[param].headerKey = tpl.key;
				}
				let name = `mm-request-param-${param}`;
				this.data.requestParams[name] = this.parseJson(JSON.stringify(this.data.paramFields[param]));
				this.data.requestParams[name].value = '';
			});
		} else {
			this.data.requestParams = {};
			this.data.paramFields = {};
		}
	};

	componentDidMount() {
		//TODO pop message to create new connection and nav to connection if there are none
		connect.getConnections().then(res => {
			this.observe(() => {
				this.data.connectionMap = CS.mapByParam('_id', res.data);
				_.forEach(Object.values(this.data.connectionMap), conn => {
					if (conn.name === this.data.endpointConnection) {
						this.data.selectedConnection = conn._id;
						conn.testing = true;
						this.data.initialConnection = JSON.parse(JSON.stringify(conn));
						return false;
					}
				});
			});
		});
	}

	componentWillUnmount() {}

	onConnectionChange(option) {
		if (option) {
			let conn = this.data.connectionMap[option.value];
			if (conn) {
				this.observe(() => {
					if (conn.type === 'http-connector' || conn.type === 'html-connector') {
						this.data.actionType = 'get';
						this.data.actionRequired = true;
					} else if (conn.type === 'sql-connector') {
						this.data.actionType = undefined;
						this.data.actionRequired = false;
					} else {
						this.data.actionType = '';
						this.data.actionRequired = true;
					}
					this.data.selectedConnection = option.value;
				});
			}
		}
	}

	parseJson = val => {
		try {
			return JSON.parse(val);
		} catch (e) {
			console.error(e);
			return undefined;
		}
	};

	mergeParams = params => {
		let newParamFields = {};
		_.forEach(Object.keys(params), param => {
			if (!this.data.paramFields[param]) {
				newParamFields[param] = {
					type: 'string',
					value: '',
					required: false
				};
			} else {
				newParamFields[param] = this.data.paramFields[param];
			}
		});

		let keys = Object.keys(newParamFields);
		let requestFields = {};
		_.forEach(keys, param => {
			if (param) {
				let name = `mm-request-param-${param}`;
				if (!this.data.requestParams[name]) {
					requestFields[name] = this.parseJson(JSON.stringify(newParamFields[param]));
				} else {
					requestFields[name] = this.data.requestParams[name];
				}
			}
		});

		return {
			requestParams: requestFields,
			paramFields: newParamFields
		};
	};

	handleConnectionChange(manager) {
		this.connectionManager = manager;
		if (this.data.endpoint && !manager.cmp.updatedState) {
			let ep = this.data.endpoint;
			let conn = JSON.parse(JSON.stringify(this.data.initialConnection));
			let config = Object.assign(conn.configuration, ep.configuration);
			conn.configuration = config;
			let oldState = manager.cmp.data;
			let newState = manager.cmp.onBuildConnectionState(conn);
			newState.disabled = oldState.disabled;
			manager.cmp.data = newState;
			manager.cmp.updatedState = true;
			manager.cmp.scanForParams();
		}
		let params = this.mergeParams(this.connectionManager.data.requestParams);
		this.observe(() => {
			this.data.requestParams = params.requestParams;
			this.data.paramFields = params.paramFields;
		});
	}

	onSaveEndpoint() {
		if (this.connectionManager) {
			let { endpoint } = this.buildTestEndpoint();
			if (this.data.endpoint) {
				endpoint._id = this.data.endpoint._id;
				connect
					.updateEndpoint(endpoint)
					.then(res => {
						RS.showSuccess();
						TS.track('Saved_Endpoint');
						ACS.populateEndpoint(res.data);
					})
					.catch(err => {
						RS.smartError(err);
					});
			} else {
				connect
					.createEndpoint(endpoint)
					.then(res => {
						this.setData('endpoint', res.data);
						TS.track('Saved_Endpoint');
						ACS.populateEndpoint(res.data);
						RS.showSuccess();
					})
					.catch(err => {
						RS.smartError(err);
					});
			}
		}
	}

	onValueChange(evt) {
		const { name, value } = evt.target;
		if (name === 'name' && !VS.validateName(value)) {
			return;
		}
		this.observe(() => {
			this.data[name] = value;
		});
	}

	onChecked(evt) {
		const { dataset, checked } = evt.target;
		this.setData(dataset.name, checked);
	}

	buildConnectionForm() {
		let id = this.data.selectedConnection;
		if (id) {
			let conn = this.data.connectionMap[id];
			if (conn) {
				conn.testing = true;
				switch (conn.type) {
					case 'http-connector': {
						return (
							<HttpConnector
								connection={this.data.initialConnection ? this.data.initialConnection : conn}
								endpoint={true}
								endpointWatcher={this.handleConnectionChange}
								key={conn.name + '-connection-form'}
							/>
						);
					}
					case 'soap-connector': {
						return (
							<SoapConnector
								connection={this.data.initialConnection ? this.data.initialConnection : conn}
								endpoint={true}
								endpointWatcher={this.handleConnectionChange}
								key={conn.name + '-connection-form'}
							/>
						);
					}
					case 'html-connector': {
						return (
							<HtmlConnector
								connection={this.data.initialConnection ? this.data.initialConnection : conn}
								endpoint={true}
								endpointWatcher={this.handleConnectionChange}
								key={conn.name + '-connection-form'}
							/>
						);
					}
					case 'ews-exchange-connector': {
						return (
							<ExchangeConnector
								connection={this.data.initialConnection ? this.data.initialConnection : conn}
								endpoint={true}
								endpointWatcher={this.handleConnectionChange}
								key={conn.name + '-connection-form'}
							/>
						);
					}
					case 'exchange-connector': {
						return (
							<ExchangeWebServiceConnector
								connection={this.data.initialConnection ? this.data.initialConnection : conn}
								endpoint={true}
								endpointWatcher={this.handleConnectionChange}
								key={conn.name + '-connection-form'}
							/>
						);
					}
					case 'sql-connector': {
						return (
							<SqlConnector
								connection={this.data.initialConnection ? this.data.initialConnection : conn}
								endpoint={true}
								endpointWatcher={this.handleConnectionChange}
								key={conn.name + '-connection-form'}
							/>
						);
					}
					default: {
						return (
							<HttpConnector
								connection={this.data.initialConnection ? this.data.initialConnection : conn}
								endpoint={true}
								endpointWatcher={this.handleConnectionChange}
								key={conn.name + '-connection-form'}
							/>
						);
					}
				}
			}
		}
		return '';
	}

	buildConnectionOptions() {
		let options = [];
		_.forEach(Object.keys(this.data.connectionMap), id => {
			let conn = this.data.connectionMap[id];
			if (conn) {
				options.push({
					label: conn.name,
					value: conn._id,
					type: conn.type
				});
			}
		});

		return options;
	}

	getConnectionImage(type) {
		switch (type) {
			case 'http-connector': {
				return rest;
			}
			case 'soap-connector': {
				return soap;
			}
			case 'html-connector': {
				return htmlImg;
			}
			case 'ews-exchange-connector': {
				return exchange;
			}
			case 'exchange-connector': {
				return ex10;
			}
			case 'sql-connector': {
				return sqlImg;
			}
			default: {
				return rest;
			}
		}
	}

	onDDActionChange(evt) {
		this.setData('actionType', evt.value);
	}

	onActionChange = evt => {
		this.setData('actionType', evt.target.value);
	};

	onTypeChange(evt) {
		this.setData('endpointType', evt.value);
	}

	getConnectionAction() {
		let id = this.data.selectedConnection;
		if (id) {
			let conn = this.data.connectionMap[id];
			if (conn) {
				switch (conn.type) {
					case 'http-connector': {
						return (
							<Dropdown
								className="action-dd"
								label="Action"
								value={this.data.actionType}
								handleChange={this.onDDActionChange}
								name="actionType"
								options={[
									{
										label: 'GET',
										value: 'get'
									},
									{
										label: 'POST',
										value: 'post'
									},
									{
										label: 'PUT',
										value: 'put'
									},
									{
										label: 'PATCH',
										value: 'patch'
									},
									{
										label: 'DELETE',
										value: 'delete'
									}
								]}
							/>
						);
					}
					case 'soap-connector': {
						return (
							<InputField
								label="Action"
								subText="SOAP action to be executed."
								type="text"
								name="testingAction"
								className="action-input"
								value={this.data.actionType}
								handleChange={this.onActionChange}
								required
								autoFocus
							/>
						);
					}
					case 'html-connector': {
						return (
							<Dropdown
								className="action-dd"
								label="Action"
								value={this.data.actionType}
								handleChange={this.onDDActionChange}
								name="actionType"
								options={[
									{
										label: 'GET',
										value: 'get'
									},
									{
										label: 'POST',
										value: 'post'
									}
								]}
							/>
						);
					}
					case 'ews-exchange-connector': {
						return (
							<InputField
								label="Operation"
								subText="Operations enable you to access information from the Exchange store."
								type="text"
								name="testingAction"
								className="action-input"
								value={this.data.actionType}
								handleChange={this.onActionChange}
								required
								autoFocus
							/>
						);
					}
					case 'exchange-connector': {
						return (
							<InputField
								label="Operation"
								subText="Operations enable you to access information from the Exchange store.."
								type="text"
								name="testingAction"
								className="action-input"
								value={this.data.actionType}
								handleChange={this.onActionChange}
								required
								autoFocus
							/>
						);
					}
					case 'sql-connector': {
						return '';
					}
					default: {
						return '';
					}
				}
			}
		}
	}

	renderConnection(option) {
		return (
			<div className="hbox vcenter connection-option">
				<img src={this.getConnectionImage(option.type)} className="connection-img" alt="connection-type" />
				<div className="name">{option.label}</div>
			</div>
		);
	}

	handlePostScriptChange(val) {
		this.setData('postScript', val);
		setTimeout(() => {
			let decorations = this.postEditor.editor.getModel().getAllDecorations();
			let errors = decorations
				.filter(decorations => {
					return decorations.options.className === 'redsquiggly';
				})
				.map(e => e);
			this.observe(() => {
				this.data.postErrors = errors;
				if (errors.length > 0 || this.data.preErrors.length > 0) {
					this.data.validJS = false;
				} else {
					this.data.validJS = true;
				}
			});
		}, 600);
	}

	handlePreScriptChange(val) {
		this.setData('preScript', val);
		setTimeout(() => {
			let decorations = this.preEditor.editor.getModel().getAllDecorations();
			let errors = decorations
				.filter(decorations => {
					return decorations.options.className === 'redsquiggly';
				})
				.map(e => e);
			this.observe(() => {
				this.data.preErrors = errors;
				if (errors.length > 0 || this.data.postErrors.length > 0) {
					this.data.validJS = false;
				} else {
					this.data.validJS = true;
				}
			});
		}, 600);
	}

	onSetEmpty = evt => {
		let name = evt.target.dataset.name;
		if (name) {
			this.observe(() => {
				if (name.indexOf('mm-request-param-') >= 0) {
					this.data.requestParams[name].value = '';
					this.data.requestParams[name].key = Math.random();
				} else {
					this.data.paramFields[name].value = '';
					this.data.paramFields[name].key = Math.random();
				}
			});
		}
	};

	onClaimChange = evt => {
		let name = evt.target.dataset.name;
		if (name) {
			this.observe(() => {
				if (name.indexOf('mm-request-param-') >= 0) {
					this.data.requestParams[name].claim = evt.target.value;
				} else {
					this.data.paramFields[name].claim = evt.target.value;
				}
			});
		}
	};

	onHeaderKeyChange = evt => {
		let name = evt.target.dataset.name;
		if (name) {
			this.observe(() => {
				if (name.indexOf('mm-request-param-') >= 0) {
					this.data.requestParams[name].headerKey = evt.target.value;
				} else {
					this.data.paramFields[name].headerKey = evt.target.value;
				}
			});
		}
	};

	onParamTypeChange = obj => {
		this.observe(() => {
			let details = this.data.paramFields[obj.param];
			if (details) {
				let req = this.data.requestParams[`mm-request-param-${obj.param}`];
				details.type = obj.value;
				req.type = obj.value;
				details.value = '';
				details.required = false;
				details.claim = '';
				details.headers = '';
				if (details.type === 'boolean') {
					details.label = 'None';
					details.value = false;
					details.key = Math.random();
					req.label = 'None';
					req.value = false;
					req.key = Math.random();
				}
				if (details.type === 'object' || details.type === 'array') {
					details.value = '';
					req.value = '';
				}
				if (details.type === 'userInfo' || details.type === 'contextHeader') {
					details.key = Math.random();
					req.key = Math.random();
				}
			}
		});
	};

	onClearValue = evt => {
		evt.persist();
		if (evt.target.dataset.name.indexOf('mm-request-param-') >= 0) {
			if (this.data.requestParams[evt.target.dataset.name].type !== 'boolean') {
				this.onSetEmpty(evt);
			}
			setTimeout(
				evt => {
					let name = evt.target.dataset.name;
					if (name) {
						this.observe(() => {
							let field = this.data.requestParams[name];
							field.value = undefined;
							if (field.type === 'boolean') {
								field.label = 'None';
								field.value = false;
								field.key = Math.random();
							}
						});
					}
				},
				50,
				evt
			);
		} else {
			if (this.data.paramFields[evt.target.dataset.name].type !== 'boolean') {
				this.onSetEmpty(evt);
			}
			setTimeout(
				evt => {
					let name = evt.target.dataset.name;
					if (name) {
						this.observe(() => {
							let field = this.data.paramFields[name];
							field.value = undefined;
							if (field.type === 'boolean') {
								field.label = 'None';
								field.value = false;
								field.key = Math.random();
							}
						});
					}
				},
				50,
				evt
			);
		}
	};

	onDefaultChange(evt) {
		let name = evt.target.dataset.name;
		if (name) {
			this.observe(() => {
				let field;
				if (name.indexOf('mm-request-param-') >= 0) {
					field = this.data.requestParams[name];
				} else {
					field = this.data.paramFields[name];
				}
				if (evt.target.type === 'checkbox') {
					field.value = evt.target.checked;
					field.label = field.value.toString();
					field.key = Math.random();
				} else {
					field.value = evt.target.value;
				}
				if (name.indexOf('mm-request-param-') >= 0) {
					this.data.requestParams[name] = field;
				} else {
					this.data.paramFields[name] = field;
				}
			});
		}
	}

	onParamObjectChange = (name, newValue) => {
		this.observe(() => {
			if (name.indexOf('mm-request-param-') >= 0) {
				let field = this.data.requestParams[name];
				field.value = newValue;
				this.data.requestParams[name] = field;
			} else {
				let field = this.data.paramFields[name];
				field.value = newValue;
				this.data.paramFields[name] = field;
			}
		});
	};

	buildTemplate() {
		let tpl = {};
		let keys = Object.keys(this.data.paramFields);
		_.forEach(keys, param => {
			let pd = this.data.paramFields[param];
			let item = {
				required: pd.required,
				type: pd.type
			};
			if (pd.value !== undefined) {
				item.default = pd.value;
				if (pd.type === 'array' && pd.value.length > 0) {
					let cvt = `{"arr":${pd.value}}`;
					let obj = this.parseJson(cvt);
					item.default = obj.arr;
				} else if (pd.type === 'array') {
					delete item.default;
				}
				if (pd.type === 'object' && pd.value.length > 0) {
					item.default = this.parseJson(pd.value);
				} else if (pd.type === 'object') {
					delete item.default;
				}
				if (pd.type === 'number') {
					item.default = Number(pd.value);
				}
			}
			if (pd.claim) {
				item.claim = pd.claim;
			}
			if (pd.headerKey) {
				item.key = pd.headerKey;
			}
			tpl[param] = item;
		});
		return tpl;
	}

	buildParamsInput = () => {
		let fields = [
			<div className="param-header hbox vcenter" key={0}>
				<div className="label name">name</div>
				<div className="label type">type</div>
				<div className="label grow-1">default value</div>
				<div className="label required">required</div>
			</div>
		];
		let params = Object.keys(this.data.paramFields);
		_.forEach(params, param => {
			if (param && param.length > 0) {
				let details = this.data.paramFields[param];
				fields.push(
					<div className="field-row hbox vcenter" key={param + '-field-row'}>
						<div className="name ellipse">{param}</div>
						<div className="type m-r-20">
							<Dropdown
								className="param-type-picker"
								value={details.type}
								handleChange={this.onParamTypeChange}
								name="type"
								options={this.getTypeOptions(param)}
							/>
						</div>
						{this.buildTypeDefault(details, param)}
						<div className="required">
							<input type="checkbox" checked={details.required} value={details.required} data-param={param} onClick={this.onRequiredChanged} />
						</div>
					</div>
				);
			}
		});
		return fields.length > 1 ? fields : [];
	};

	onRequiredChanged = evt => {
		let name = evt.target.dataset.param;
		if (name) {
			this.observe(() => {
				let details = this.data.paramFields[name];
				if (details) {
					details.required = evt.target.checked;
					let req = this.data.requestParams[`mm-request-param-${name}`];
					req.required = evt.target.checked;
				}
			});
		}
	};

	getTypeOptions = param => {
		return [
			{
				label: 'String',
				value: 'string',
				param: param
			},
			{
				label: 'Number',
				value: 'number',
				param: param
			},
			{
				label: 'Boolean',
				value: 'boolean',
				param: param
			},
			{
				label: 'Object',
				value: 'object',
				param: param
			},
			{
				label: 'Array',
				value: 'array',
				param: param
			},
			{
				label: 'X-Mad-Context Header',
				value: 'contextHeader',
				param: param
			}
		];
	};

	buildTypeDefault(details, param) {
		switch (details.type) {
			case 'string': {
				return (
					<div className="inline-btn-input hbox vcenter default">
						<input
							className="text-input"
							type="text"
							placeholder={details.value === '' ? 'Empty String' : 'None'}
							value={details.value}
							data-name={param}
							onChange={this.onDefaultChange}
						/>
						<button className="btn inline-btn no-radius vbox hcenter vcenter" data-name={param} onClick={this.onSetEmpty}>
							Set as empty
						</button>
						<button className="btn inline-btn  vbox hcenter vcenter" data-name={param} onClick={this.onClearValue}>
							Clear
						</button>
					</div>
				);
			}
			case 'number': {
				return (
					<div className="inline-btn-input hbox vcenter default">
						<input className="text-input" type="number" placeholder="None" value={details.value} data-name={param} onChange={this.onDefaultChange} />
						<button className="btn inline-btn  vbox hcenter vcenter" data-name={param} onClick={this.onClearValue}>
							Clear
						</button>
					</div>
				);
			}
			case 'object': {
				return (
					<SmallJSONEditor
						value={details.value}
						onChange={this.onParamObjectChange}
						className="param-editor"
						minLines={5}
						maxLines={10}
						returnName={param}
					/>
				);
			}
			case 'array': {
				return (
					<SmallJSONEditor
						value={details.value}
						onChange={this.onParamObjectChange}
						className="param-editor"
						minLines={5}
						maxLines={10}
						returnName={param}
					/>
				);
			}
			case 'boolean': {
				return (
					<div className="inline-btn-input hbox vcenter default">
						<input type="checkbox" checked={details.value} data-name={param} onChange={this.onDefaultChange} key={details.key + param} />
						<div className="value-label grow-1">{details.label}</div>
						<button className="btn grey vbox hcenter vcenter" data-name={param} onClick={this.onClearValue}>
							Clear
						</button>
					</div>
				);
			}
			case 'userInfo': {
				return (
					<div className="inline-btn-input hbox vcenter default" key={details.key + param}>
						{param.indexOf('mm-request-param') < 0 && (
							<input
								className="text-input claim-input"
								type="text"
								placeholder="Claim"
								value={details.claim}
								data-name={param}
								onChange={this.onClaimChange}
							/>
						)}
						<input
							className="text-input"
							type="text"
							placeholder={details.value === '' ? 'Empty String' : 'None'}
							value={details.value}
							data-name={param}
							onChange={this.onDefaultChange}
							disabled={param.indexOf('mm-request-param') >= 0}
						/>
						<button
							className="btn inline-btn no-radius vbox hcenter vcenter"
							data-name={param}
							onClick={this.onSetEmpty}
							disabled={param.indexOf('mm-request-param') >= 0}
						>
							Set as empty
						</button>
						<button
							className="btn inline-btn  vbox hcenter vcenter"
							data-name={param}
							onClick={this.onClearValue}
							disabled={param.indexOf('mm-request-param') >= 0}
						>
							Clear
						</button>
					</div>
				);
			}
			case 'contextHeader': {
				return (
					<div className="inline-btn-input hbox vcenter default" key={details.key + param}>
						{param.indexOf('mm-request-param') < 0 && (
							<input
								className="text-input claim-input"
								type="text"
								placeholder="Key"
								value={details.headerKey}
								data-name={param}
								onChange={this.onHeaderKeyChange}
							/>
						)}
						<input
							className="text-input"
							type="text"
							placeholder={details.value === '' ? 'Empty String' : 'None'}
							value={details.value}
							data-name={param}
							onChange={this.onDefaultChange}
						/>
						<button className="btn inline-btn no-radius vbox hcenter vcenter" data-name={param} onClick={this.onSetEmpty}>
							Set as empty
						</button>
						<button className="btn inline-btn  vbox hcenter vcenter" data-name={param} onClick={this.onClearValue}>
							Clear
						</button>
					</div>
				);
			}
			default: {
				return (
					<div className="inline-btn-input hbox vcenter default">
						<input
							className="text-input"
							type="text"
							placeholder={details.value === '' ? 'Empty String' : 'None'}
							value={details.value}
							data-name={param}
							onChange={this.onDefaultChange}
						/>
						<button className="btn inline-btn no-radius vbox hcenter vcenter" data-name={param} onClick={this.onSetEmpty}>
							Set as empty
						</button>
						<button className="btn inline-btn  vbox hcenter vcenter" data-name={param} onClick={this.onClearValue}>
							Clear
						</button>
					</div>
				);
			}
		}
	}

	toggleAsync() {
		this.setData('async', !this.data.async);
	}

	buildTestValues() {
		let test = {};
		let keys = Object.keys(this.data.requestParams);
		_.forEach(keys, param => {
			let name = param.replace('mm-request-param-', '');
			let rd = this.data.requestParams[param];
			if (rd.value !== undefined) {
				test[name] = rd.value;
				if (rd.type === 'array' && rd.value.length > 0) {
					let cvt = `{"arr":${rd.value}}`;
					let obj = this.parseJson(cvt);
					test[name] = obj.arr;
				} else if (rd.type === 'array') {
					delete test[name];
				} else if (rd.type === 'number' && rd.value.length > 0) {
					test[name] = Number(rd.value);
				}
				if (rd.type === 'object' && rd.value.length > 0) {
					test[name] = this.parseJson(rd.value);
				}
				if (rd.type === 'number' && rd.value.length === 0) {
					delete test[name];
				}
				if (rd.type === 'userInfo' && rd.value.length <= 0) {
					delete test[name];
				}
				if (rd.type === 'contextHeader' && rd.value.length <= 0) {
					delete test[name];
				}
			}
		});
		return test;
	}

	buildTestEndpoint = () => {
		let conn = this.connectionManager.builder();
		if (conn) {
			conn.endpoint.action = this.data.actionType;
			if (this.connectionManager.cmp.data.type === 'sql-connector') {
				conn.endpoint.action = 'query';
			}
			conn.testValues = this.buildTestValues();
			conn.testValues._async = this.data.async;
			conn.endpoint.description = this.data.description;
			conn.endpoint.type = this.data.endpointType;
			conn.endpoint.name = this.data.name;
			conn.endpoint.version = 2;
			conn.endpoint.templates = this.buildTemplate();
			if (this.data.cacheTime) {
				conn.endpoint.cacheForMinutes = Number(this.data.cacheTime);
			}
			if (this.data.postProcessingOpen || this.data.preProcessingOpen) {
				conn.endpoint.hooks = {};
				if (this.data.postProcessingOpen) {
					conn.endpoint.hooks['post-processing'] = this.data.postScript;
				}
				if (this.data.preProcessingOpen) {
					conn.endpoint.hooks['pre-processing'] = this.data.preScript;
				}
			}
		} else {
			return null;
		}
		return conn;
	};

	runTest() {
		this.endpointToTest = this.buildTestEndpoint();
		if (this.endpointToTest) {
			this.setData('runningTest', true);
		}
	}

	toggleTestRunner() {
		this.setData('runningTest', !this.data.runningTest);
	}

	onTestEndpoint() {
		return connect.testConnection(this.endpointToTest);
	}

	validForm = () => {
		if (!this.data.validJS) {
			return false;
		}
		if (this.data.name.length <= 0) {
			return false;
		}
		if (!this.connectionManager || !this.connectionManager.builder) {
			return false;
		}
		if (this.data.actionRequired && this.data.actionType.length <= 0) {
			return false;
		}
		return true;
	};

	render() {
		let {
			selectedConnection,
			preProcessingOpen,
			postProcessingOpen,
			preScript,
			postScript,
			name,
			description,
			endpointType,
			cacheTime,
			runningTest,
			async
		} = this.data;
		return (
			<div className={`integration-endpoint-form animated fadeIn ${this.props.className ? this.props.className : ''}`}>
				{!this.data.endpoint && <h3>1. Select a connection</h3>}
				<div className="hbox">
					<Dropdown
						className="connection-dropdown m-r-20"
						label={!this.data.endpoint ? 'Select a connection' : 'Connection'}
						value={selectedConnection}
						handleChange={this.onConnectionChange}
						placeholder={!this.data.endpoint ? 'Select a connection' : 'Connection'}
						name="connectionDropdown"
						renderValue={this.renderConnection}
						renderOption={this.renderConnection}
						options={this.buildConnectionOptions()}
						disabled={this.data.endpoint ? true : false}
						subText="Connections are sets of configurations that allows to connect to an external service. You can create any number of Integration Endpoints based on a given Connection."
					/>
					<div className="spacer" />
					{this.getConnectionAction()}
				</div>
				{!this.data.endpoint && selectedConnection && <h3>2. Configure your connection</h3>}
				{this.buildConnectionForm()}
				{!this.data.endpoint && selectedConnection && <h3>3. Configure Pre & Post Processing</h3>}
				{selectedConnection && (
					<div className="step-card shadow">
						<ToggleRow
							className="ep-toggle-row"
							name="Request pre-processing"
							details={
								'A request pre-processing hook (or prehook, for short) is a regular JavaScript function that receives a merged configuration object and context as arguments, with interpolated parameter values, and returns a configuration object valid for the connector.'
							}
							toggleOn={preProcessingOpen}
							keyName={'preProcessingOpen'}
							onToggle={this.onChecked}
							content={
								<div className="pre-processing-content vbox vcenter">
									<CodeEditor
										language="javascript"
										value={preScript}
										className="editor-ctn"
										onChange={this.handlePreScriptChange}
										registerTo={this.preEditor}
									/>
									<ScriptHelp type={'preScript'} />
								</div>
							}
						/>
						<ToggleRow
							className="ep-toggle-row"
							name="Response transformation"
							details={
								'A response post-processing hook (or posthook, for short) is a regular JavaScript function that receives the raw response of the executed endpoint and context as arguments and returns a new transformed response to the final API user.'
							}
							toggleOn={postProcessingOpen}
							keyName={'postProcessingOpen'}
							onToggle={this.onChecked}
							content={
								<div className="post-processing-content vbox vcenter">
									<CodeEditor
										language="javascript"
										value={postScript}
										className="editor-ctn"
										onChange={this.handlePostScriptChange}
										registerTo={this.postEditor}
									/>
									<ScriptHelp type={'postScript'} />
								</div>
							}
						/>
					</div>
				)}
				{!this.data.endpoint && selectedConnection && <h3>4. Endpoint Details</h3>}
				{selectedConnection && (
					<div className="endpoint-details-form step-card shadow">
						<InputField
							name="name"
							label="Name"
							value={name}
							handleChange={this.onValueChange}
							subText="Use only lowercase characters, numbers or hyphens."
							type="text"
							disabled={this.data.endpoint ? true : false}
							required
						/>
						<InputField
							name="description"
							label="Description"
							value={description}
							handleChange={this.onValueChange}
							subText="An optional free-form description for this endpoint. Write any additional information that would help you identify this endpoint later. You will be able to search endpoints matching against this field."
							type="textarea"
						/>
						<h3 className="sub-header">Endpoint type & caching</h3>
						<div className="small-text">
							Integration endpoints may be configured as Query endpoints or Operation endpoints. Set your endpoint as Query if it retrieves data from
							a service. For Query endpoints you can configure an amount of minutes for the platform to cache the response in order to improve the
							application performance. Operation type, on the other hand, should be used for endpoints that create or update data on a server, so they
							cannot be cached.
						</div>
						<div className="endpoint-type-ctn hbox">
							<Dropdown
								className="endpoint-type-dd"
								label="Type"
								value={endpointType}
								handleChange={this.onTypeChange}
								placeholder="Select a type"
								name="endpointType"
								options={[
									{
										label: 'Operation',
										value: 'Operation'
									},
									{
										label: 'Query',
										value: 'Query'
									}
								]}
								required
							/>
							{endpointType === 'Query' && (
								<InputField
									name="cacheTime"
									label="Cache responses for"
									value={cacheTime}
									handleChange={this.onValueChange}
									subText="Time in minutes."
									type="number"
									className="cache-time-field"
								/>
							)}
						</div>
						<div className="test-ctn vbox">
							<div className={`${Object.keys(this.data.paramFields).length > 0 ? '' : 'hidden'}`}>
								<h3>Parameters configuration</h3>
								<div className="desc-text">
									To enforce the invocation of the endpoint with valid parameter values, define their type and specify whether they are required or
									not, in which case you can provide a default value to use.
								</div>
							</div>
							{this.buildParamsInput()}
							<SampleRequestCard
								requestParams={this.data.requestParams}
								buildRequestFields={this.buildTypeDefault}
								validTest={true}
								onTest={this.runTest}
								async={async}
								toggleAsync={this.toggleAsync}
							/>
							<TestRunnerModal isOpen={runningTest} onClose={this.toggleTestRunner} runTest={this.onTestEndpoint} async={async} />
						</div>
					</div>
				)}
				{selectedConnection && (
					<div className="btn-ctn">
						<button className="btn primary" disabled={!this.validForm()} onClick={this.onSaveEndpoint}>
							Save
						</button>
					</div>
				)}
			</div>
		);
	}
}

export default IntegrationEndpointForm;



// WEBPACK FOOTER //
// ./src/views/endpoints-panel/integration-endpoint-form/IntegrationEndpointForm.js